export default {
    feeder(state) {
        return state.feeder;
    }
}